<aside class="cd-sidebar" aria-label="Counselor navigation">
  <div class="cd-logo-wrapper">
    <img src="assets/logos/SVG/Handle_Horz_Logo_White.svg" alt="Handle" class="app-logo-img" />
  </div>

  <nav aria-label="Main menu">
    <mat-nav-list class="cd-nav">
      <a
        *hasPermission="permissions.ORG.VIEW_SCHOOLS"
        mat-list-item
        class="cd-nav-item active"
        routerLink="/districts"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        aria-label="Schools"
        data-testid="district-schools-nav-item"
      >
        <mat-icon matListItemIcon aria-hidden="true">dashboard</mat-icon>
        <span matListItemTitle>Schools</span>
      </a>
      <a
        *hasPermission="permissions.ORG.MANAGE_ONEROSTER"
        mat-list-item
        class="cd-nav-item"
        routerLink="/districts/integration"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        aria-label="Integration"
        data-testid="district-integration-nav-item"
      >
        <mat-icon matListItemIcon aria-hidden="true">cable</mat-icon>
        <span matListItemTitle>Integration</span>
      </a>
      <a
        *hasPermission="permissions.REPORTS.VIEW"
        mat-list-item
        class="cd-nav-item"
        routerLink="/districts/reports"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        aria-label="Reports"
        data-testid="district-reports-nav-item"
      >
        <mat-icon matListItemIcon aria-hidden="true">outbox</mat-icon>
        <span matListItemTitle>Report</span>
      </a>
    </mat-nav-list>
  </nav>

  <div class="cd-user" aria-label="Logged in user">
    <div class="cd-user-avatar" aria-hidden="true">
      {{ ((user$ | async)?.preferredName || (user$ | async)?.firstName)?.[0]
      }}{{ (user$ | async)?.lastName?.[0] }}
    </div>
    <div>
      <div class="cd-user-name">
        {{
          `${(user$ | async)?.preferredName || (user$ | async)?.firstName} ${(user$ | async)?.lastName}`
        }}
      </div>
      <!-- <div class="cd-user-school">Waltham High School</div> -->
    </div>
  </div>
</aside>
